import React from "react"
import { graphql } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { config } from "@fortawesome/fontawesome-svg-core"
import { faFilePdf } from "@fortawesome/free-regular-svg-icons"
import { faLink } from "@fortawesome/free-solid-svg-icons"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { Options } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import classnames from "classnames"

export default function LinksAndPdfs(props: Queries.LinksAndPdfsFragment) {
  const { links, pdfs } = props

  const linksRenderOptions: Options = {
    renderNode: {
      [BLOCKS.QUOTE]: (_node, children) => (
        <blockquote className="ml-6 border-l-4 border-secondary pl-3">
          {children}
        </blockquote>
      ),
      [INLINES.HYPERLINK]: (node, children) => {
        const isPdf = node.data.uri.includes(".pdf")

        return (
          <a
            className="inline-flex items-baseline justify-start gap-x-1.5"
            href={node.data.uri}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <FontAwesomeIcon
              className={classnames("inline-block w-4 translate-y-0.5", {
                "text-base": isPdf
              })}
              icon={isPdf ? faFilePdf : faLink}
            />
            {children}
          </a>
        )
      }
    }
  }

  config.autoAddCss = false

  return pdfs || links ? (
    <div className="mt-4 text-sm">
      {pdfs && (
        <ul>
          {pdfs.map(({ title, file }, index) => (
            <li key={index}>
              <a
                className="inline-flex items-baseline justify-start gap-x-1"
                href={file.url}
              >
                <FontAwesomeIcon
                  className="translate-y-0.5 text-base"
                  icon={faFilePdf}
                  fixedWidth
                />
                {title}
              </a>
            </li>
          ))}
        </ul>
      )}

      {links &&
        renderRichText({ ...links, references: [] }, linksRenderOptions)}
    </div>
  ) : null
}

export const fragment = graphql`
  fragment LinksAndPdfs on ContentfulResource {
    pdfs {
      title
      file {
        url
      }
    }
    links {
      raw
    }
  }
`
